import axios from "axios";
import { baseApiUrl, getHttpHeaders } from "./ApiUtils";
import { refreshTokenKey } from "./OAuth";

export async function loginUser(credentials) {
  const url = `${baseApiUrl}/api/auth/login`;
  let config = getHttpHeaders();
  let data = JSON.stringify(credentials);
  return await axios.post(url, data, config);
}
export async function loginMicroSoftUser(authorizationCode) {
  const url = `${baseApiUrl}/api/auth/microsoft/login`;
  let config = getHttpHeaders();
  let data = JSON.stringify(authorizationCode);
  return await axios.post(url, data, config);
}
export async function loginOktaUser(authorizationCode) {
  const url = `${baseApiUrl}/api/auth/okta/login`;
  let config = getHttpHeaders();
  let data = JSON.stringify(authorizationCode);
  return await axios.post(url, data, config);
}

export async function logoutUser() {
  const url = `${baseApiUrl}/api/auth/logout`;
  let config = getHttpHeaders();
  let data = { refreshToken: localStorage.getItem(refreshTokenKey) };
  return await axios.post(url, data, config);
}
